import { SVGProps, Ref, forwardRef } from 'react';

export const ArchiveboxFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 3.5C0 5.688.312 6 2.5 6h19c2.188 0 2.5-.312 2.5-2.5 0-2.187-.312-2.5-2.5-2.5h-19C.312 1 0 1.313 0 3.5m22 4.3H2v8c.03 5.394 1.88 7.197 7.333 7.197h5.334c5.454 0 7.302-1.803 7.333-7.197v-8M15.5 12h-7v-1.8h7z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ArchiveboxFilledSize24Glyph.displayName = 'ArchiveboxFilledSize24Glyph';
